<template>
  <div class="content">
    <div class="Theme">
      <div class="Banner">欢迎来到再生资源云平台监管工作台</div>
    </div>

    <!-- 业务数据统计区 -->
    <div class="businessSection">
      <div class="sectionTitle">
        <i class="el-icon-s-data"></i>
        <span>业务数据统计</span>
      </div>
      <div class="businessContainer">
        <div
          class="miniCard"
          @click="choseCard(item)"
          :key="item.key"
          v-for="item in businessData"
        >
          <div class="miniCard_body">
            <div class="miniCard_mid">
              <div class="miniCard_left">
                <img :src="item.url" alt="" />
              </div>
              <div class="miniCard_right">
                <div>{{ item.totle }}</div>
                <div>{{ item.type }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 外部平台快捷入口 -->
    <div class="quickLinksSection">
      <div class="sectionTitle">
        <i class="el-icon-link"></i>
        <span>平台快捷入口</span>
      </div>
      <div class="quickLinksContainer">
        <div
          class="linkCard"
          v-for="item in externalLinks"
          :key="item.key"
          @click="openExternalLink(item)"
        >
          <div class="linkIcon">
            <span class="icon-char">{{ item.iconChar }}</span>
          </div>
          <div class="linkInfo">
            <div class="linkName">{{ item.name }}</div>
            <div class="linkDesc">{{ item.description }}</div>
          </div>
          <div class="linkArrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimeRange } from '@/util/dateRange';
import { getPunishmentTrend } from '@/API/Punishment/Punishment';
export default {
  name: 'index',
  data() {
    return {
      // 业务数据卡片
      businessData: [
        {
          totle: '0',
          type: '处罚事件',
          key: 'penaltyEvent',
          path: '/supervisionHomepage/PunishmentDetails',
          url: require('@/assets/recycling/temporaryPicture/Penaltyevent.png'),
        },
      ],
      // 外部链接
      externalLinks: [
        {
          name: '信用中国',
          description: '官方信用信息公示平台',
          path: 'https://www.creditchina.gov.cn/',
          key: 'creditChina',
          iconChar: '🏛️',
        },
        {
          name: '无废四川',
          description: '四川省固体废物管理平台',
          path: 'https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin',
          key: 'wasteFreeSichuan',
          iconChar: '♻️',
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getPunishmentTrends();
    });
  },
  methods: {
    choseCard(item) {
      this.$router.push(item.path);
    },
    openExternalLink(item) {
      window.open(item.path, '_blank');
    },
    getPunishmentTrends() {
      this.businessData[0].totle = 0;
      let parmrs = {
        beginDate: getTimeRange('3').startTime,
        endDate: getTimeRange('3').endTime,
      };
      getPunishmentTrend(parmrs).then((res) => {
        if (res.code === 200) {
          res.data.classified.forEach((item) => {
            this.businessData[0].totle += item.value;
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 20px 250px;

  .Theme {
    .Banner {
      background: url('~@/assets/recycling/temporaryPicture/bg2.png') no-repeat
        center;
      background-size: cover;
      height: 100px;
      border-radius: 8px;
      font-size: 26px;
      font-weight: 700;
      color: rgb(255, 255, 255);
      line-height: 100px;
      padding-left: 16px;
    }
  }

  // 分区标题
  .sectionTitle {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin: 24px 0 16px 0;
    padding-left: 12px;
    border-left: 4px solid #409eff;

    i {
      margin-right: 8px;
      color: #409eff;
      font-size: 20px;
    }
  }

  // 业务数据区
  .businessSection {
    margin-bottom: 32px;

    .businessContainer {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      min-height: 200px;

      .miniCard {
        width: calc((100% - 40px) / 3);
        max-width: 400px;
        min-width: 300px;
        height: 184px;
        background-color: #ffffff;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          border: 1px solid rgb(40, 153, 254);
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(40, 153, 254, 0.2);
        }

        .miniCard_body {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          background: url('~@/assets/recycling/temporaryPicture/img_1.png')
            no-repeat center;
          background-size: cover;
          display: flex;
          justify-content: center;
          align-items: center;

          .miniCard_mid {
            height: 80px;
            width: 80%;
            display: flex;

            .miniCard_left {
              width: 80px;
              background: url('~@/assets/recycling/temporaryPicture/img_2.png')
                no-repeat center;
              background-size: cover;
              position: relative;

              img {
                width: 40px;
                height: 40px;
                position: absolute;
                left: 25%;
                top: 15%;
              }
            }

            .miniCard_right {
              width: calc(100% - 80px);
              padding-left: 25px;
              display: flex;
              align-items: center;
              flex-wrap: wrap;

              div:first-child {
                width: 100%;
                font-size: 24px;
                font-weight: 700;
                line-height: 32px;
              }

              div:last-child {
                width: 100%;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }

  // 快捷链接区
  .quickLinksSection {
    .quickLinksContainer {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
      gap: 16px;

      .linkCard {
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
        border: 1px solid #e4e7ed;
        border-radius: 12px;
        padding: 20px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          border-color: #409eff;
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
          transform: translateX(4px);

          .linkArrow {
            color: #409eff;
          }
        }

        .linkIcon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          flex-shrink: 0;

          .icon-char {
            font-size: 32px;
          }
        }

        .linkInfo {
          flex: 1;

          .linkName {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 4px;
          }

          .linkDesc {
            font-size: 13px;
            color: #909399;
          }
        }

        .linkArrow {
          color: #c0c4cc;
          font-size: 20px;
          transition: all 0.3s ease;
          margin-left: 12px;
        }
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .content {
    padding: 0 !important;

    .Theme {
      .Banner {
        height: 40px !important;
        line-height: 40px !important;
        font-size: 14px !important;
      }
    }

    .sectionTitle {
      font-size: 16px;
      margin: 16px 0 12px 0;
      padding: 0 16px;
    }

    .businessSection {
      .businessContainer {
        padding: 0 16px;
        gap: 12px;

        .miniCard {
          width: 100% !important;
          height: 80px !important;

          .miniCard_mid {
            height: 40px !important;

            .miniCard_left {
              width: 20px !important;
              height: 20px !important;
            }
          }

          .miniCard_right div {
            font-size: 14px !important;
          }
        }
      }
    }

    .quickLinksSection {
      .quickLinksContainer {
        padding: 0 16px;
        grid-template-columns: 1fr;

        .linkCard {
          padding: 16px;

          .linkIcon {
            width: 50px;
            height: 50px;

            .icon-char {
              font-size: 28px;
            }
          }
        }
      }
    }
  }
}
</style>
